import PropTypes from 'prop-types';

export const shapePaginator = PropTypes.shape({
  count: PropTypes.number,
  end: PropTypes.number,
  endIndex: PropTypes.number,
  nextPage: PropTypes.func,
  offset: PropTypes.number,
  page: PropTypes.number,
  previousPage: PropTypes.func,
  reset: PropTypes.func,
  result: PropTypes.arrayOf(
    PropTypes.object,
  ),
  start: PropTypes.number,
  startIndex: PropTypes.number,
  updateOffset: PropTypes.func,
  updatePage: PropTypes.func,
})
